import React, { useRef, useState, useContext } from "react";
import { Button, Form, Toast, ToastContainer, Container, Col, Row } from "react-bootstrap";
import { BiArrowBack, BiErrorCircle } from "react-icons/bi";
import { FaLock } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { axiosOpen } from "../../api/axios";
import logo from "../../assests/images/launch-wild-logo.png";
import { Toaster as Toasters } from "../../component/Toaster/Toaster";
import useAuth from "../../Hooks/useAuth";
import { toast, Toaster } from 'react-hot-toast';

const LoginForm = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    email: "",
  });
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");

  const [showToster, setShowToster] = useState({ show: false, message: "" });
  const [userToken, setUserToken] = useState(null);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [signup, setSignup] = useState(false);
  const [emailNotification, setEmailNotification] = useState(false);

  const resetFields = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setRePassword("");
    setUsername("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email === "" || password === "") return false;
    (async () => {
      try {
        const response = await axiosOpen.post("user/login", { email, password });
        setAuth({ role: response.data.user.role, userID: response?.data?.user?.id });
        localStorage.userToken = JSON.stringify(response?.data?.token);
        localStorage.userID = JSON.stringify(response?.data?.user?.id);
        localStorage.userDetails = JSON.stringify(response?.data?.user);
        response.data.user.role === "superadmin" && navigate("/subscription/list");
        response.data.user.role === "user" && navigate("/");
      } catch (err) {
        if (err.response.status === 401) {
          setShowToster({ show: true, message: "Invalid Credential" });
        }
      }
    })();
  };

  const handleSignup = (e) => {
    e.preventDefault();
    if (firstName === "" || lastName === "" || username === "" || password === "" || rePassword === "" || email === "")
      return false;
    (async () => {try {
      await axiosOpen.post("add/admin", {
        fname: firstName,
        lname: lastName,
        username,
        email,
        password,
      });
      resetFields();
      setSignup((value) => !value);
      toast.success('Registration Successful')
    } catch (error) {
      
      toast.error(error.response.data.msg)
    }
      
    })();
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    if (email === "") return false;
    (async () => {
      try {
        const response = await axiosOpen.post("user/forgotpassword", { email });
        setEmailNotification(true);
        setTimeout(() => { 
          navigate("/", { replace: true });
          resetFields();
        }, 2000);
      } catch (err) {
        setShowToster({ show: true, message: "Email is not registered" });
      }
    })();
  };

  const handleForgotPasswordSwitch = () => {
    resetFields();
    setForgotPassword((currentValue) => !currentValue);
  };

  const handleSignupSwitch = () => {
    resetFields();
    setSignup((value) => !value);
  };

  const validateFirstName = (firstname) => {
    let firstNamePattern = /^[A-Za-z]{5,30}$/;
    if (!firstNamePattern.test(firstname)) {
      setErrors((error) => ({
        ...error,
        firstName: "Min 5 and Max 30 Characters are allowed. No special characters allowed",
      }));
    } else {
      setErrors((error) => ({
        ...error,
        firstName: "",
      }));
    }
  };

  const validateLastName = (lastname) => {
    let lastNamePattern = /^[A-Za-z]{5,30}$/;
    if (!lastNamePattern.test(lastname)) {
      setErrors((error) => ({
        ...error,
        lastName: "Min 5 and Max 30 Characters are allowed. No special characters allowed",
      }));
    } else {
      setErrors((error) => ({
        ...error,
        lastName: "",
      }));
    }
  };

  const validateEmail = (emailAddress) => {
    const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!emailPattern.test(emailAddress)) {
      setErrors((error) => ({
        ...error,
        email: "Invalid Email Address",
      }));
    } else {
      setErrors((error) => ({
        ...error,
        email: "",
      }));
    }
  };

  const validateUsername = (usernameID) => {
    const usernamePattern = /^[a-zA-Z0-9_-]{3,16}$/;
    if (!usernamePattern.test(usernameID)) {
      setErrors((error) => ({
        ...error,
        username:
          "Only allows letters, digits, underscore, and hyphen, Has a minimum length of 3 characters, maximum length of 16 characters",
      }));
    } else {
      setErrors((error) => ({
        ...error,
        username: "",
      }));
    }
  };

  const validatePassword = (pswd) => {
    const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\-_=+\\|[\]{};:'",.<>/?]).{8,}$/;
    if (!passwordPattern.test(pswd)) {
      setErrors((error) => ({
        ...error,
        password: "At least 8 characters. Use a mix of letters (uppercase and lowercase), numbers, and symbols.",
      }));
    } else {
      setErrors((error) => ({
        ...error,
        password: "",
      }));
    }
  };

  const validateRePassword = (repswd) => {
    if (password !== repswd) {
      setErrors((error) => ({ ...error, rePassword: "Password doesn't match" }));
    } else {
      setErrors((error) => ({ ...error, rePassword: "" }));
    }
  };

  return (
    <>
    <Toaster
      position="top-right"
      reverseOrder={false}
    />
    <div className="login-page-container">
      <div className="login-form-wrapper">
        {showToster && (
          <ToastContainer position="top-end" className="p-3">
            <Toast
              onClose={() => setShowToster({ show: false, message: "" })}
              show={showToster.show}
              delay={3000}
              autohide
            >
              <Toast.Header className="toaster-header">
                <BiErrorCircle className="toaster-icon" />
                <div className="toaster-body">
                  <strong className="me-auto">Oops!</strong>
                  <br />
                  <strong className="me-auto">{showToster.message}</strong>
                </div>
              </Toast.Header>
            </Toast>
          </ToastContainer>
        )}

        {
        emailNotification && (<Toasters
        title={`Email sent to ${email}`}
        currentState={emailNotification}
        handleToaster={() => setEmailNotification(false)}
        variant="success"
        delay="5000"
      />)
        }
        <Container>
          <Row>
            <Col>
              {!signup && !forgotPassword && (
                <div className="form-signin">
                  <div className="w-100 d-flex justify-content-center align-items-center">
                    <img alt="brand logo" src={logo} width="180" height="auto" />
                  </div>
                  <h1>LOGIN</h1>
                  <Form className="form w-100" onSubmit={handleSubmit}>
                    <Form.Floating className="mb-3 ">
                      <Form.Control
                        id="floatingEmailInput"
                        type="email"
                        placeholder="Email"
                        autoComplete="off"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        required
                      />
                      <label htmlFor="floatingEmailInput">Email Address</label>
                    </Form.Floating>
                    <Form.Floating>
                      <Form.Control
                        id="floatingPasswordCustom"
                        type="password"
                        placeholder="Password"
                        autoComplete="off"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        required
                      />
                      <label htmlFor="floatingPasswordCustom">Password</label>
                    </Form.Floating>
                    <Form.Group className="w-100 d-flex justify-content-between align-items-center mt-4">
                      <Button variant="primary" className="login-btn" type="submit">
                        Login
                      </Button>
                      <Button
                        variant="link"
                        className="text-decoration-none text-white"
                        onClick={handleForgotPasswordSwitch}
                      >
                        Forgot Password ?
                      </Button>
                    </Form.Group>
                    <div className="text-center text-white mt-4 font-size-12 w-100">
                      Don't have an account&nbsp;
                      <span className="font-weight-bold cursor-pointer" onClick={handleSignupSwitch}>
                        Signup
                      </span>
                    </div>
                  </Form>
                </div>
              )}

              {!signup && forgotPassword && (
                <div className="form-signin">
                  <div className="d-flex w-100">
                    <BiArrowBack
                      style={{
                        fontSize: "25px",
                        color: "#FFFFFF",
                        cursor: "pointer",
                      }}
                      onClick={handleForgotPasswordSwitch}
                    />
                    <div className="w-100 d-flex justify-content-center align-center">
                      <img alt="brand logo" src={logo} width="150" height="auto" className="mr-3" />
                    </div>
                  </div>
                  <h1>Forgot Password</h1>
                  <Form className="form w-100" onSubmit={handleForgotPassword}>
                    <Form.Floating className="mb-2">
                      <Form.Control
                        className="mb-3"
                        id="floatingEmailInput"
                        type="email"
                        placeholder="Email"
                        autoComplete="off"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        required
                      />
                      <label htmlFor="floatingEmailInput">Email Address</label>
                    </Form.Floating>
                    <Button variant="primary" className="login-btn mx-auto w-100" type="submit">
                      Forgot Password
                    </Button>
                  </Form>
                </div>
              )}

              {signup && (
                <div className="form-signin">
                  <div className="d-flex w-100">
                    <BiArrowBack
                      style={{
                        fontSize: "25px",
                        color: "#FFFFFF",
                        cursor: "pointer",
                      }}
                      onClick={handleSignupSwitch}
                    />
                    <div className="w-100 d-flex justify-content-center align-item-center">
                      <img alt="brand logo" src={logo} width="150" height="auto" className="mr-4" />
                    </div>
                  </div>
                  <h1>Create an account</h1>
                  <Form className="form w-100" onSubmit={handleSignup}>
                    <Form.Floating className="mb-3 ">
                      <Form.Control
                        id="first-name-input"
                        type="text"
                        autoComplete="off"
                        onChange={(e) => {
                          validateFirstName(e.target.value);
                          setFirstName(e.target.value);
                        }}
                        value={firstName}
                        placeholder="First name"
                        required
                      />
                      <label htmlFor="first-name-input">First Name</label>
                      <div className="error">{errors.firstName}</div>
                    </Form.Floating>
                    <Form.Floating className="mb-3 ">
                      <Form.Control
                        id="last-name-input"
                        type="text"
                        autoComplete="off"
                        onChange={(e) => {
                          validateLastName(e.target.value);
                          setLastName(e.target.value);
                        }}
                        value={lastName}
                        placeholder="Last name"
                        required
                      />
                      <label htmlFor="last-name-input">Last Name</label>
                      <div className="error">{errors.lastName}</div>
                    </Form.Floating>
                    <Form.Floating className="mb-3 ">
                      <Form.Control
                        id="email-id-input"
                        type="email"
                        autoComplete="off"
                        onChange={(e) => {
                          validateEmail(e.target.value);
                          setEmail(e.target.value);
                        }}
                        value={email}
                        placeholder="Email"
                        required
                      />
                      <label htmlFor="email-id-input">Email Address</label>
                      <div className="error">{errors.email}</div>
                    </Form.Floating>
                    <Form.Floating className="mb-3">
                      <Form.Control
                        id="username-input"
                        type="username"
                        autoComplete="off"
                        onChange={(e) => {
                          validateUsername(e.target.value);
                          setUsername(e.target.value);
                        }}
                        value={username}
                        placeholder="username"
                        required
                      />
                      <label htmlFor="username-input">Username</label>
                      <div className="error">{errors.username}</div>
                    </Form.Floating>
                    <Form.Floating className="mb-3 ">
                      <Form.Control
                        id="password-input"
                        type="password"
                        autoComplete="off"
                        onChange={(e) => {
                          validatePassword(e.target.value);
                          setPassword(e.target.value);
                        }}
                        value={password}
                        placeholder="Password"
                        required
                      />
                      <label htmlFor="password-input">Password</label>
                      <div className="error">{errors.password}</div>
                    </Form.Floating>
                    <Form.Floating className="mb-3 ">
                      <Form.Control
                        id="re-password-input"
                        type="password"
                        autoComplete="off"
                        onChange={(e) => {
                          validateRePassword(e.target.value);
                          setRePassword(e.target.value);
                        }}
                        value={rePassword}
                        placeholder="Re-Password"
                        required
                      />
                      <label htmlFor="re-password-input">Re-Password</label>
                      <div className="error">{errors.rePassword}</div>
                    </Form.Floating>
                    <Form.Group
                      controlId="formBasicCheckbox"
                      className="w-100 d-flex justify-content-between align-items-center"
                    >
                      <Button
                        variant="primary"
                        className="login-btn d-flex justify-content-center align-items-center w-100 p-2"
                        type="submit"
                      >
                        <FaLock style={{ fontSize: "15px" }} />
                        &nbsp;Create Account
                      </Button>
                    </Form.Group>
                  </Form>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    
    </>
  );
};

export default LoginForm;
